import { Component } from "react";

import { TextArea } from "components/textarea/TextArea";
import "./CommitmentTable.scss";

class CommitmentTable extends Component {
  componentWillMount() {
    this.setState({
      currentYear: this.props.year,
      indexOfCurrentYear:
        this.props.commitment.activityTable.yearlyReports.findIndex(
          (x) => x.year === this.props.year
        ),
      lastYear: this.props.lastYear,
      indexOfLastYear:
        this.props.commitment.activityTable.yearlyReports.findIndex(
          (x) => x.year === this.props.lastYear
        )
    });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      currentYear: nextProps.year,
      indexOfCurrentYear:
        nextProps.commitment.activityTable.yearlyReports.findIndex(
          (x) => x.year === nextProps.year
        ),
      lastYear: nextProps.lastYear,
      indexOfLastYear:
        nextProps.commitment.activityTable.yearlyReports.findIndex(
          (x) => x.year === nextProps.lastYear
        )
    });
  }

  lastYearHadInvoices = () => {
    let hadInvoices = [];
    if (this.state.indexOfLastYear !== -1) {
      hadInvoices = this.props.commitment.activityTable.yearlyReports[
        this.state.indexOfLastYear
      ].report.map((item) => {
        return item.totalInvoiced > 0;
      });
    }
    return hadInvoices.includes(true);
  };

  render() {
    let totaltotalinvoiced = 0;
    let totalOpenAmount = 0;
    let totalSuggestedAmount = 0;
    let totalInvoicedLastYear = 0;

    const rows = this.props.commitment.activityTable.yearlyReports[
      this.state.indexOfCurrentYear
    ].report.map((item, index) => {
      totaltotalinvoiced += Math.round(parseInt(item.totalInvoiced));
      totalOpenAmount += Math.round(parseInt(item.openAmount));
      totalSuggestedAmount += Math.round(parseInt(item.suggestedAmount));

      let lastYearTotalInvoicedOnActivity = null;
      const lastYearsTotalInvoiced = (taskNumber, property) => {
        const lastYear =
          this.props.commitment.activityTable.yearlyReports[
            this.state.indexOfCurrentYear - 1
          ];
        if (lastYear !== null && lastYear !== undefined) {
          // Exists a year
          if (lastYear.report !== null) {
            //check if last year had an entry for the same activity
            const LastYearReportIndex = lastYear.report.findIndex((x) => {
              return x.type.taskNumber === taskNumber;
            });
            // if it does, return that value
            if (LastYearReportIndex > -1) {
              return lastYear.report[LastYearReportIndex][`${property}`];
            }
          }
        }
      };
      // Get invoiced amount for activity the year before
      lastYearTotalInvoicedOnActivity = lastYearsTotalInvoiced(
        item.type.taskNumber,
        "totalInvoiced"
      );
      if (lastYearTotalInvoicedOnActivity) {
        // add it to the total-row
        totalInvoicedLastYear += parseInt(lastYearTotalInvoicedOnActivity);
      }

      return (
        <tr
          key={index}
          className={item.openAmount !== 0 ? "openAmount" : ""}
          title={item.openAmount !== 0 ? "Uppdrag har öppet PGU > 0" : ""}
        >
          <td>
            <strong>
              {item.type.taskNumber} - {item.type.activityDescription}
            </strong>
          </td>
          <td>{item.type.taskDescription || ""}</td>
          <td>
            {lastYearTotalInvoicedOnActivity
              ? Math.round(lastYearTotalInvoicedOnActivity)
              : 0}
          </td>
          <td>{item.totalInvoiced}</td>
          <td>{Math.round(item.openAmount)}</td>
          <td>{item.suggestedAmount}</td>
          <td>
            <TextArea
              style={{ width: "300px" }}
              value={item.comment || ""}
              readOnly={true}
            />
          </td>
        </tr>
      );
    });

    return (
      <div className={"table-wrapper"}>
        <table className="min-w-400">
          <thead>
            <tr>
              <th>Uppgift</th>
              <th>Uppgiftsbeskrivning</th>
              <th>Fakturerat {Math.round(this.state.currentYear - 1) || ""}</th>
              <th>Fakturerat {Math.round(this.state.currentYear) || ""}</th>
              <th>Öppet PGU</th>
              <th>Föreslaget belopp</th>
              <th>Kommentar</th>
            </tr>
          </thead>
          <tbody>
            {rows}
            <tr>
              <td>
                <strong>Totalt</strong>
              </td>
              <td />
              <td>
                <strong>{totalInvoicedLastYear} SEK</strong>
              </td>
              <td>
                <strong>{totaltotalinvoiced} SEK</strong>
              </td>
              <td>
                <strong>{totalOpenAmount} SEK</strong>
              </td>
              <td>
                <strong>{totalSuggestedAmount} SEK</strong>
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

export default CommitmentTable;
